import { lazy } from 'react'

export const AbPage = lazy(() => import('@pages/AbPage'))
export const AffiseRecalcPage = lazy(() => import('@pages/AffiseRecalcPage'))
export const AdBlacklistPage = lazy(() => import('@pages/AdBlacklistPage'))
export const AdExpensesPage = lazy(() => import('@pages/AdExpensesPage'))
export const AdMappingPage = lazy(() => import('@pages/AdMappingPage'))
export const AdRecalcQueuePage = lazy(() => import('@pages/AdRecalcQueuePage'))
export const AdNetworkExpensesPage = lazy(() => import('@pages/AdNetworkExpensesPage'))
export const AdSpotsPage = lazy(() => import('@pages/AdSpotsPage'))
export const LtvPage = lazy(() => import('@pages/LtvPage/index'))
export const MxBlacklistPage = lazy(() => import('@pages/MxBlacklistPage'))
export const MxHourlyPage = lazy(() => import('@pages/MxHourlyPage'))
export const MxSessionsPage = lazy(() => import('@pages/MxSessionsPage'))
export const PaymentsGameDaysPage = lazy(() => import('@pages/PaymentsGameDaysPage'))
export const PaymentsPage = lazy(() => import('@pages/PaymentsPage'))
export const PaymentsPerHourPage = lazy(() => import('@pages/PaymentsPerHourPage'))
export const PaymentsRawPage = lazy(() => import('@pages/PaymentsRawPage'))
export const PaymentsTopUsersPage = lazy(() => import('@pages/PaymentsTopUsersPage'))
export const PostbacksPage = lazy(() => import('@pages/PostbacksPage'))
export const ReportsPage = lazy(() => import('@pages/ReportsPage'))
export const RetentionExportPage = lazy(() => import('@pages/RetentionExportPage'))
export const RetentionPage = lazy(() => import('@pages/RetentionPage'))
export const RevSharePage = lazy(() => import('@pages/RevSharePage'))
export const SummaryPage = lazy(() => import('@pages/SummaryPage'))
export const UsersPage = lazy(() => import('@pages/UsersPage'))
